module.exports = __webpack_public_path__ + "static/media/cloud-upload.0bef4139.svg";